import React from 'react'
import styled from 'styled-components'
import { Container } from 'react-bootstrap'
import SharedTitle from '~/components/UI/SharedTitle'
import Text from '~/components/UI/Text'
import { useTranslation } from '~/i18n'
import Box from '~/components/UI/Box'
import Icon from '~/components/UI/Icon'
import { COLORS } from '~/components/UI/Constants'

const MyContainer = styled(Container)`
  padding: 80px 0;

  table {
    border-radius: 4px;
    border-collapse: collapse;
    tr:first-child td {
      padding-bottom: 32px;
    }

    td:not(:last-child) {
      border-right: 1px solid rgba(26, 26, 26, 0.1);
    }
    td {
      color: ${COLORS.TEXT};
      width: 25%;
      padding: 10px 20px;

      :last-child {
        color: #fff;
        background-color: #0084ff;
      }
      :not(:first-child) {
        font-weight: bold;
      }

      :nth-child(2), :nth-child(3) {
        background-color: #f9fafc;
      }
    }
  }
`

const TableContainer = styled.div`
  border: 1px solid rgba(26, 26, 26, 0.1);
  border-radius: 16px;
  overflow: hidden;
`

const CompareTable = () => {
  const [t] = useTranslation()
  return (
    <MyContainer>
      <Container>
        <SharedTitle centered padding='0 0 48px 0'>
          {t`Bảng tính mô phỏng đầu tư`}
          <Text centered>
            ({t`Ví dụ phân tích, đánh giá quy chiếu với bất động sản tầm giá 1.5 tỷ đến 2 tỷ`})
          </Text>
        </SharedTitle>
        <TableContainer>
          <table>
            <tbody>
              <tr>
                <td></td>
                <td>
                  <Text centered size={22}>{t`Truyền Thống`}</Text>
                  <Text centered>
                    {t`(Có vay ngân hàng)`}
                  </Text>
                </td>
                <td>
                  <Text centered size={22}>{t`Truyền Thống`}</Text>
                  <Text centered>
                    {t`(Không vay ngân hàng)`}
                  </Text>
                </td>
                <td>
                  <Box flex justify='center' align='center'>
                    <Text color='#fff' padding='0 10px 0 0' size={22} centered>
                      {t`Infina`}
                    </Text>
                    <Icon name='verified' />
                  </Box>
                </td>
              </tr>
              {/* <tr>
              <td></td>
              <td>
                <ImgCdn src='/img/traditional_1.svg' />
              </td>
              <td>
                <ImgCdn src='/img/traditional_2.svg' />
              </td>
              <td>
                <ImgCdn src='/img/realstake_way.svg' />
              </td>
            </tr> */}
              <tr>
                <td>{t`Vốn cần có`}</td>
                <td>
                  {t`450 triệu - 600 triệu`}
                </td>
                <td>
                  {t`1.5 tỷ - 2 tỷ`}
                </td>
                <td>
                  {t`20 triệu - 200 triệu`}
                </td>
              </tr>
              <tr>
                <td>{t`Đóng theo tiến độ ( 5%/đợt )`}</td>
                <td>
                  {t`450 triệu - 600 triệu`}
                  <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                    {t`(đóng đủ trong vòng 1 - 2 tháng)`}
                  </p>
                </td>
                <td>
                  {t`Từ 75 triệu/đợt`}
                </td>
                <td>
                  {t`Từ 1 triệu/đợt`}
                </td>
              </tr>
              <tr>
                <td>{t`Gốc hàng tháng trả ngân hàng`}</td>
                <td>
                  {t`4,5 triệu - 6 triệu`}
                  <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                    {t`(nếu CĐT không hỗ trợ)`}
                  </p>
                </td>
                <td>
                  {t`0`}
                </td>
                <td>
                  {t`0`}
                </td>
              </tr>
              <tr>
                <td>{t`Lãi vay hàng tháng trả ngân hàng`}</td>
                <td>
                  {t`9 triệu - 12 triệu`}
                  <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                    {t`(nếu CĐT không hỗ trợ)`}
                  </p>
                </td>
                <td>
                  {t`0`}
                </td>
                <td>
                  {t`0`}
                </td>
              </tr>
              <tr>
                <td>{t`Tổng tiền hàng tháng phải trả ngân hàng`}</td>
                <td>
                  {t`13.5 triệu - 18 triệu`}
                  <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                    {t`(nếu CĐT không hỗ trợ)`}
                  </p>
                </td>
                <td>
                  {t`0`}
                </td>
                <td>
                  {t`0`}
                </td>
              </tr>
              <tr>
                <td>{t`Kênh giao dịch`}</td>
                <td>
                  {t`Thị trường truyền thống`}
                </td>
                <td>
                  {t`Thị trường truyền thống`}
                </td>
                <td>
                  {t`Thị trường truyền thống & Hệ sinh thái Infina`}
                </td>
              </tr>
              <tr>
                <td>{t`Tính thanh khoản`}</td>
                <td>
                  {t`Theo tình hình thị trường`}
                </td>
                <td>
                  {t`Theo tình hình thị trường`}
                </td>
                <td>
                  {t`Infina cam kết mua lại bất cứ lúc nào trong 2 năm đầu`}
                </td>
              </tr>
              <tr>
                <td>{t`Lợi nhuận cam kết`}</td>
                <td>
                  {t`Không ai cam kết, tuỳ vào thị trường`}
                </td>
                <td>
                  {t`Không ai cam kết, tuỳ vào thị trường`}
                </td>
                <td>
                  {t`Có thể từ 6% đến 9% một năm`}
                  <p style={{ fontWeight: 'normal', fontSize: 13 }}>
                    {t`(nhận thêm tiền lời khi bán ra)`}
                  </p>
                </td>
              </tr>
              <tr>
                <td>{t`Tính an toàn của khoản đầu tư`}</td>
                <td>
                  {t`Phụ thuộc hoàn toàn vào CĐT`}
                </td>
                <td>
                  {t`Phụ thuộc hoàn toàn vào CĐT`}
                </td>
                <td>
                  {t`Khoản đầu tư được bảo lãnh 100% bởi ngân hàng`}
                </td>
              </tr>
              <tr>
                <td>{t`Thủ tục pháp lý`}</td>
                <td>
                  {t`Tự tìm hiểu hoặc thông qua bên môi giới`}
                </td>
                <td>
                  {t`Tự tìm hiểu hoặc thông qua bên môi giới`}
                </td>
                <td>
                  {t`Có Infina cùng đội cố vấn pháp lý của công ty luật quốc tế đồng hành cùng bạn`}
                </td>
              </tr>
            </tbody>
          </table>
        </TableContainer>
      </Container>
    </MyContainer>
  )
}

export default CompareTable
